/**
 * ブランドのドロップダウンで名前の左に出す小さな代表ロゴ (利用者指示 2026-10-30)。
 * 代表ロゴはブランド一覧と同じ選び方 (既定 → 先頭)、地色も同じ判定 (白抜きの透過ロゴだけ黒地・それ以外は白地)。
 * ロゴが無いブランドは空の枠を出して、名前の頭を揃える。
 */
import type { BrandLogo } from '../../../features/brands/types';
import { logoCardBackground, pickPrimaryLogo } from '../../../features/brands/logoAttributes';
import './BrandLogoChip.css';

export function BrandLogoChip({ logos }: { logos?: BrandLogo[] | null }) {
  const logo = pickPrimaryLogo(logos);
  const url = logo?.logos?.url;
  if (!logo || !url) return <span className="brand-logo-chip brand-logo-chip--empty" aria-hidden="true" />;
  return (
    <span className="brand-logo-chip" style={{ background: logoCardBackground(logo) }} aria-hidden="true">
      <img src={url} alt="" loading="lazy" />
    </span>
  );
}
